import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './components/Home';
import Rezervace from './components/Rezervace';
import Galerie from './components/Galerie';
import Information from './components/Information';
import Layout from './components/Layout';
import Overeni from './components/Overeni';
import Platba from './components/Platba';
import TransferPayment from './components/TransferPayment';
import CashPayment from './components/CashPayment';
import Kontakt from './components/Kontakt';
import MobilePanoramaPage from './components/MobilePanoramaPage';
import Cenik from './components/Cenik';
import NotFound from './components/NotFound';

function App() {
  return (
    <Router>
      <Navbar />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/rezervace" element={<Rezervace />} />
          <Route path="/verify" element={<Overeni />} />
          <Route path="/galerie" element={<Galerie />} />
          <Route path="/platba" element={<Platba />} />
          <Route path="/information" element={<Information />} />
          <Route path="/transfer-payment" element={<TransferPayment />} />
          <Route path="/cash-payment" element={<CashPayment />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="/panorama-viewer" element={<MobilePanoramaPage />} />
          <Route path="/mobile-panorama" element={<MobilePanoramaPage />} />
          <Route path="/cenik" element={<Cenik />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
      <Footer />
    </Router>
  );
}

export default App;
